import React from 'react';
import { RadioGroup } from '@youngcapital/component-library';
import { mixed } from 'yup';
import { asFieldset, FIELDSET_PROPTYPES } from '../asFieldset';
import { getRadioProps } from '../helpers/utils';

const FreelanceFieldset = ({ getFieldProps, t }) => {
  const wantToFreelance = getFieldProps('freelancer').value;

  return (
    <>
      <h3>{t('fieldset_freelance.header')}</h3>
      <p>
        {t('fieldset_freelance.coc_comment')}
        <span className='input__required'>*</span>
      </p>
      <RadioGroup
        variant='fixed'
        {...getRadioProps('freelancer', getFieldProps)}
        items={[
          { value: true, label: t('general.yes') },
          { value: false, label: t('general.no') }
        ]}
      />
      {wantToFreelance && (
        <>
          <p className='mt-2x'>
            {t('fieldset_freelance.has_coc_number')}
            <span className='input__required'>*</span>
          </p>
          <RadioGroup
            variant='fixed'
            {...getRadioProps('has_coc_number', getFieldProps)}
            items={[
              { value: true, label: t('general.yes') },
              { value: false, label: t('general.no') }
            ]}
          />
        </>
      )}
    </>
  );
};

FreelanceFieldset.type = 'freelance';

FreelanceFieldset.initialValues = () => ({
  freelancer: null,
  has_coc_number: null
});

FreelanceFieldset.validationSchema = () => ({
  freelancer: mixed().required(),
  has_coc_number: mixed().when('freelancer', {
    is: true,
    then: mixed().required()
  })
});

FreelanceFieldset.propTypes = FIELDSET_PROPTYPES;

export default asFieldset(FreelanceFieldset);
